import { createTheme } from '@mui/material/styles'
import { blue, grey, red } from '@mui/material/colors'
import { appTypography } from '../../typography'
import { datePickerTheme } from '../../datePickerTheme'
import { darkMessageCategoryPalette } from '../shared/messageCategoryPalette'

const darkTheme = createTheme({
  ...datePickerTheme,
  name: 'dark',
  typography: appTypography,
  customSizes: {
    drawerWidth: 240
  },
  palette: {
    customColors: {
      praetorianMain: '#1C294D'
    },
    mode: 'dark',
    ...darkMessageCategoryPalette,
    deviceInput: {
      background: {
        inactive: blue[900],
        active: red[600]
      },
      text: {
        inactive: grey[100],
        active: grey[100]
      }
    },
    deviceOutput: {
      background: {
        inactive: blue[900],
        active: red[600]
      },
      text: {
        inactive: grey[100],
        active: grey[100]
      }
    }
  }
})

export default darkTheme
